import { StyledOrderCardBlock } from './styled';

const OrderCardBlock = StyledOrderCardBlock;

OrderCardBlock.displayName = 'OrderCardBlock';

export { OrderCardBlock };
